<template>
  <div>
    <div id="swagger"></div>
  </div>
</template>

<script>
  import SwaggerUI from 'swagger-ui'
  import 'swagger-ui/dist/swagger-ui.css';

  export default {
    name: 'ApiDocs',

    mounted: function() {

      SwaggerUI({
        dom_id: '#swagger',
        url: 'https://api.postgresqlco.nf/q/openapi'
      })

    }
  }
</script>

<style>
  #swagger, #swagger h2, #swagger a, #swagger p, #swagger button, .swagger-ui .info a, #swagger span, #swagger .opblock-summary-description, #swagger h4 > a.nostyle span, .swagger-ui .responses-inner h4, .swagger-ui .responses-inner h5, #swagger h3, #swagger .auth-container h4, .swagger-ui label {
      font-family: 'Nunito', Helvetica, Arial, sans-serif;
      font-size: .9rem;
  }

  #swagger .nostyle span, #swagger pre span, #swagger .highlight-code, #swagger table td, .swagger-ui .code, .swagger-ui code {
      font-family: 'Ubuntu Mono', monospace;
      font-size: .85rem;
      line-height: 1.25;
  }

  #swagger {
      top: -50px;
      position: relative;
  }

  #swagger a, .swagger-ui .btn  {
    color: var(--blue);
  }

  #swagger .auth-container code {
    color: #000;
  }

  #swagger .required {
    color: var(--red);
  }

  #swagger code.language-bash, #swagger code, .darkmode #swagger .response-control-media-type__accept-message code, .darkmode .model-container td, .darkmode .model-container span, .darkmode .swagger-ui input[type=text] {
    color: #fff;
  }

  #swagger a:hover {
    color: var(--lblue);
  }

  .swagger-ui .btn {
    border-color: var(--blue);
    }

  #swagger .response-control-media-type__accept-message code {
    color: var(--gray5)
  }

  .darkmode #swagger th {
    background: none;
  }

  .swagger-ui .info hgroup.main a, #swagger p, .swagger-ui .info a {
    font-size: .9rem;
  }

  #swagger h2 {
    font-size: 1.5rem;
    color: var(--blue);
    display: block;
    margin-bottom: 20px;
  }

  #swagger h4 > a.nostyle span, #swagger h3 {
    color: var(--blue);
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: 800;
  }

  /*#swagger h4 {
    padding-left: 5px;
    padding-right: 5px;
    margin: 0 -20px
  }*/

  .swagger-ui small {
    font-size: .8rem !important;
  }

  .swagger-ui .wrapper {
    padding: 0;
  }

  .swagger-ui .opblock {
    margin-top: 20px;
  }

  .swagger-ui .opblock-tag, .swagger-ui section.models.is-open h4, .swagger-ui section.models {
    border-color: var(--gray2);
  }

  pre span, #swagger table.model span {
    line-height: 1.25;
  }

  .swagger-ui .info .title small {
    top: 4px;
    margin-left: 10px;
    padding: 3px 7px;
    background: rgba(77, 79, 92, .25);
  }

  .swagger-ui .info .title small pre {
    color: #4D4F5C;
    background: none;
    overflow: hidden;
  }

  .swagger-ui .info .title small.version-stamp {
    background: rgba(0, 250, 0, .25);
  }

  .swagger-ui .info .title small.version-stamp pre {
      color: #03CC03;
  }

  /*#swagger .scheme-container {
    border: 1px solid #f0f0f1;
    border-radius: 5px;
  }*/

  #swagger .scheme-container {
      position: absolute;
      right: -10px;
      top: 0;
      margin: 0;
      padding: 0;
      background: none;
      box-shadow: none;
  }

  .swagger-ui .opblock-tag {
    margin: 0;
  }

  .swagger-ui .opblock.opblock-get, .swagger-ui .opblock.opblock-get .opblock-summary {
    border-color: #086af9;
    background: rgba(8,106,249,.025);
  }

  .swagger-ui .opblock.opblock-get .opblock-summary-method, .swagger-ui .opblock.opblock-get .tab-header .tab-item.active h4 span:after {
    background: #086af9;
  }

  .swagger-ui .opblock.opblock-post, .swagger-ui .opblock.opblock-post .opblock-summary {
    border-color: #149100;
    background: rgba(20,145,0,.025);
  }

  .swagger-ui .opblock.opblock-post .opblock-summary-method, .swagger-ui .opblock.opblock-post .tab-header .tab-item.active h4 span:after {
    background: #149100;
  }

  .swagger-ui .opblock.opblock-delete {
    background: rgba(249,62,62,.025);
  }

  .swagger-ui .opblock.opblock-put {
    border-color: #ff9d00;
    background: rgba(255,157,0,.025);
  }

  .swagger-ui .opblock.opblock-put .opblock-summary-method, .swagger-ui .opblock.opblock-put .tab-header .tab-item.active h4 span:after {
    background: #ff9d00;
  }

  .swagger-ui .opblock.opblock-patch, .swagger-ui .opblock.opblock-patch .opblock-summary {
    border-color: #6A21F7;
    background: rgba(106,33,247,.025);
  }

  .swagger-ui .opblock.opblock-patch .opblock-summary-method, .swagger-ui .opblock.opblock-patch .tab-header .tab-item.active h4 span:after {
    background: #6A21F7;
  }

  .swagger-ui .opblock-tag:hover, .swagger-ui section.models .model-container {
    background: rgba(166, 167, 174, .1);
  }

  .swagger-ui .opblock .opblock-section-header {
    background: none;
    border-bottom: 1px solid var(--gray2);
    box-shadow: none;
  }

  .swagger-ui .wrapper .block div span:first-of-type .opblock-tag {
    border-top: 1px solid var(--gray2);
  }

  #swagger .highlight-code pre, .swagger-ui .opblock-body pre.microlight {
    background: var(--gray5) !important;
  }

  .swagger-ui .response-control-media-type--accept-controller select {
    box-shadow: none;
    background-color: transparent;
    border: 1px solid var(--darkborder);
  }

  .swagger-ui input[disabled], .swagger-ui select[disabled], .swagger-ui textarea[disabled] {
    background: var(--gray1);
  }

  #swagger .auth-btn-wrapper button:not(.authorize) {
    color: var(--gray4);
    border-color: var(--gray4);
  }

  .darkmode #swagger .highlight-code pre, .darkmode .swagger-ui .opblock-body pre.microlight, .darkmode .swagger-ui input[type=text] {
    background: rgba(166, 167, 174, .1) !important;
  }

  .darkmode #swagger .swagger-ui .opblock-tag, .darkmode #swagger .scheme-container, .darkmode .swagger-ui .opblock-tag, .darkmode .swagger-ui section.models.is-open h4, .darkmode .swagger-ui section.models, .darkmode .swagger-ui .opblock .opblock-section-header, .darkmode .swagger-ui .wrapper .block div span:first-of-type .opblock-tag, .darkmode .swagger-ui .dialog-ux .modal-ux, .darkmode .swagger-ui .dialog-ux .modal-ux-header, .darkmode .swagger-ui input[type=text] {
    border-color: var(--darkborder)
  }

  .darkmode #swagger h4, .darkmode #swagger .opblock-summary-path, .darkmode #swagger .model-title, .darkmode .swagger-ui table thead tr td, .darkmode .swagger-ui table thead tr th, .darkmode td.response-col_status, .darkmode .swagger-ui .response-col_links, .darkmode .swagger-ui .responses-inner h4, .darkmode .swagger-ui .responses-inner h5, .darkmode td.response-col_description, .darkmode .swagger-ui .parameter__name, .darkmode .swagger-ui .parameter__extension, .darkmode .swagger-ui .parameter__in, .darkmode .swagger-ui .parameter__type, .darkmode #swagger .auth-container h4, .darkmode .swagger-ui label {
    color: var(--darktitle)
  }

  .darkmode #swagger .opblock-summary-description, .darkmode .swagger-ui .info .title small:not(.version-stamp) pre, .darkmode .renderedMarkdown p, .darkmode .swagger-ui .opblock-description-wrapper p, .darkmode .swagger-ui .opblock-external-docs-wrapper p, .darkmode .swagger-ui .opblock-title_normal p, .darkmode .swagger-ui .dialog-ux .modal-ux {
    color: var(--darktext);
  }

  .darkmode #swagger .opblock-summary-method{
    color: var(--darkbg);
  }

  .darkmode #swagger svg.arrow path {
    fill: #7A7B85;
  }

  .darkmode #swagger .scheme-container, .darkmode .swagger-ui .dialog-ux .modal-ux  {
    background-color: var(--darkbg);
  }

  .darkmode .swagger-ui .opblock .opblock-summary svg {
    filter: invert(1) brightness(1.5);
  }

  .darkmode .swagger-ui .expand-methods svg, .darkmode .swagger-ui .expand-operation svg, .darkmode .swagger-ui section.models h4 svg, .darkmode .swagger-ui .model-toggle:after, .darkmode select.content-type, .darkmode .swagger-ui input[disabled], .darkmode .swagger-ui select[disabled], .darkmode .swagger-ui textarea[disabled], .darkmode button.close-modal svg {
    filter: invert(1) brightness(.5);
  }

</style>